import React, { useContext, useEffect, useState } from 'react'
import { ReportContext } from '../ReportContext'
import { AuthContext } from '../../auth/AuthContext'
import IssuesTable from './IssuesTable';
import { motion } from "framer-motion";
import { FaMapMarkedAlt } from "react-icons/fa";

export default function IssuesAssigned() {
  const { issues } = useContext(ReportContext)
  const { currentUser } = useContext(AuthContext)
  const [filteredIssues, setFilteredIssues] = useState([])

  useEffect(() => {
    if (Array.isArray(issues) && !!currentUser && currentUser?.id) {
      const assignedIssues = issues.filter(
        (issue) => issue.solution?.assigned_to?.user_id === currentUser.id
      )
      setFilteredIssues(assignedIssues)
    }
  }, [issues, currentUser])


  return (
    <motion.div
      className="container my-4 p-4 shadow rounded position-relative"
      style={{ background: "#f8f9fa", border: "1px solid #dee2e6" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <button 
        className='btn btn-outline-danger position-absolute end-0 top-0 m-2'
        onClick={()=> window.history.back()}
        >❌</button>
      <motion.div
        className="d-flex align-items-center justify-content-start gap-5 mb-4"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2 }}
      >
        <FaMapMarkedAlt size={28} className="text-success" />
        <h2 className="text-success fw-bold m-0">Assigned Issues To Resolve</h2>
      </motion.div>

      {!!filteredIssues?.length ? (
        <>
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
          >
            <IssuesTable issues={filteredIssues} />
          </motion.div>
        </>
      ) : (
        <motion.div
          className="alert alert-info text-center mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          You currently have no issues to Manage.
        </motion.div>
      )}
    </motion.div>
  )
}
